/**
 * Utility pages by slug (`docs/UTILITIES.md` §6) — the same seam as
 * `custom-reports/index.ts`, for pages that change data rather than read it.
 *
 * A utility has its own endpoints under `/api/utilities/<slug>/`, each
 * authorised server-side exactly as a report is. Being listed here grants
 * nothing; it only says which component draws the page.
 */

import type { ComponentType } from 'react'

import { SalesForecastUpload } from './sales-forecast-upload/SalesForecastUpload'
import { SalesLists } from './sales-lists/SalesLists'

export interface UtilityProps {
  readonly slug: string
  readonly department: string
}

export type UtilityMap = Readonly<Record<string, ComponentType<UtilityProps>>>

export const UTILITIES: UtilityMap = {
  'sales-forecast-upload': SalesForecastUpload,
  'sales-lists': SalesLists,
}
